import React, { Fragment } from "react";

const VisionContent = [
  {
    title: "Our History",
    desc: `<b>Ada Lovelace</b> was an English mathematician who was the first person to publish the first complex computer algorithm in 1843. She did this long before any computer existed as it was devised for the Analytical Engine which never got built. This algorithm was detailed in as <b><i>Note G</i></b>.
    Getting inspired from such a great level of innovation, <b>Deepak Singh Bisht</b>, who has himself worked as a techie for more than a decade with some of the giants in the industry, decided to bring a technological advancement in the year 2021, by provide reliable and innovative technical solution for modern-day business problems. `,
    fadwae: "fade-up",
    dataDelay: "",
  },
  {
    title: "Our Mission",
    desc: `Technology is driving the innovation. Technology is driving the creativity. The use of technology is going to determine our worker's ability to compete in the 21st century global marketplace. The vision is to enable our customers with all the tools needed to fulfill their end goals.`,
    fade: "fade-up",
    dataDelay: "100",
  },
  {
    title: "Our Vission",
    desc: `To be known for the trust that we build with our customers. To provide the value for the time as well as money spent by our customers. To innovate things that will help our customers to compete very efficiently in the global marketplace.`,
    fade: "fade-up",
    dataDelay: "200",
  },
];

const FancyFeatureTwentyTwo = () => {
  return (
    <Fragment>
      <div className="row gx-xxl-5">
        {VisionContent.map((val, i) => (
          <div
            key={i}
            className="col-lg-4 col-sm-6 d-flex"
            data-aos={val.fade}
            data-aos-delay={val.dataDelay}
          >
            <div className="block-style-fourteen mt-35">
              <h5>{val.title}</h5>
              <p><div dangerouslySetInnerHTML={{ __html: val.desc }} /></p>
            </div>

            {/* /.block-style-fourteen */}
          </div>
        ))}
      </div>
    </Fragment>
  );
};

export default FancyFeatureTwentyTwo;
